// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5c6c8c0c","150":"f7e73e7a","472":"9361d4a7","488":"54de2514","786":"97681690"}[chunkId] + ".chunk.js";
};